import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { ParamsClean } from '@/common/decorators/params-clean'

export interface QueryParams {
  /** 页码（最小页码：1） */
  page: number
  /** 每页数量 */
  limit: number
  /** 排序,true-正序，false-倒序 */
  asc?: boolean
  /** 排序字段（端口号：port_num,终端数量：device_total） */
  sort?: string
  /** 是否风险端口 */
  is_risk_port?: number
}

export interface PortItem {
  /** 端口号 */
  port_num: number
  /** 协议 */
  protocol?: string
  /** 监听的进程名 */
  process_name?: string
  /** 绑定IP */
  bind_ip?: string
  /** 终端数量 */
  device_count?: number
  /** 风险参考（是否已知：0->未知，1->已知） */
  is_known_risk?: number|boolean
  /** 风险参考（详情说明） */
  risk_detail?: string
  /** 系统类型 1-windows 2-linux 3-win server */
  system_type: number
}
export interface portStatResponseData {
  /** 已阻断端口数量 */
  blocked_port_count: number
  risk_port_count?: number
}
export interface portTypeStatResponseData {
  /** 未知端口数量 */
  unknown_port_count: number
  risk_port_count?: number
}

export interface PortTypeDistribution {
  /** 风险端口数量 */
  risk_port_count: number
  /** 未知端口数量 */
  unknown_port_count: number
}
@Injectable()
export class PortManageService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  getPortList (data: QueryParams) {
    return this.http.post<{
      /** 端口列表 */
      list: PortItem[]
      /** 总数 */
      total: number
    }>('/portcontrol/port/list', data)
  }

  @ParamsClean()
  getRiskPortList (data: QueryParams) {
    return this.http.post<{
      /** 端口列表 */
      port_list: PortItem[]
    }>('/portcontrol/top-risk/get', data)
  }
  getPortcontrolPortStat () {
    return this.http.post<portStatResponseData>('/portcontrol/port-stat', {})
  }
  getPortcontrolPortTypeStat () {
    return this.http.post<portTypeStatResponseData>('/portcontrol/port_type_stat', {})
  }
}
